import { MutationTree } from 'vuex';
import {
  AcademicFormation,
  AddressInfo,
  IdentificationDocument,
  IdentificationDocumentFinancialSponsor,
  PersonalData,
  PersonalDataFinancialSponsor,
  SponsorAddressInfo,
  StudentDataState,
} from './state';
import { CountyDTO } from '@/store/graphql/queries/westerosAdmissionsQueries';
import Vue from 'vue';

const mutations: MutationTree<StudentDataState> = {
  SET_PERSONAL_DATA(state, personalData: PersonalData) {
    state.personalData = { ...state.personalData, ...personalData };
  },

  SET_ACADEMIC_FORMATION(state, academicFormation: AcademicFormation) {
    state.academicFormation = academicFormation;
  },

  SET_PERSONAL_DATA_FINANCIAL_SPONSOR(state, dataFinancialSponsor: PersonalDataFinancialSponsor) {
    state.personalDataFinancialSponsor = dataFinancialSponsor;
  },

  SET_IDENTIFICATION_DOCUMENT(state, identificationDocument: IdentificationDocument) {
    state.identificationDocument = identificationDocument;
  },

  SET_IDENTIFICATION_DOCUMENT_FINANCIAL_SPONSOR(
    state,
    identificationDocumentFinancialSponsor: IdentificationDocumentFinancialSponsor,
  ) {
    state.identificationDocumentFinancialSponsor = identificationDocumentFinancialSponsor;
  },

  SET_RACE_OPTIONS(state, raceOptions: string[]) {
    state.raceOptions = raceOptions;
  },

  SET_GENDER_OPTIONS(state, genderOptions: string[]) {
    state.genderOptions = genderOptions;
  },

  SET_NATIONALITY_OPTIONS(state, nationalityOptions: string[]) {
    state.nationalityOptions = nationalityOptions;
  },

  // SET_PLACE_OF_BIRTH_OPTIONS(state, placeOfBirthOptions: string[]) {
  //   state.placeOfBirthOptions = placeOfBirthOptions;
  // },

  SET_HOUSEHOLD_INCOME_OPTIONS(state, householdIncomeOptions: string[]) {
    state.householdIncomeOptions = householdIncomeOptions;
  },

  SET_COUNTY_OPTIONS_UNINFORMED(state) {
    const countyUninformed: CountyDTO = {
      county: state.notInformed,
      countyFullName: state.notInformed,
      id: '000000',
      uf: state.notInformed,
    };

    Vue.set(state.countys, countyUninformed.id, {
      ...state.countys[countyUninformed.id],
      ...countyUninformed,
    });
  },

  SET_COUNTYS_OPTIONS(state, countysOptions: CountyDTO[]) {
    countysOptions.forEach(value => {
      Vue.set(state.countys, value.id, {
        ...state.countys[value.id],
        ...value,
      });
    });
  },

  SET_LOADING_COUNTYS_OPTIONS(state, value: boolean) {
    state.loadingCountysOptions = value;
  },

  SET_STATES_OPTIONS(state, statesOptions: string[]) {
    state.statesOptions = statesOptions;
  },

  SET_ISSUER_OPTIONS(state, issuerOptions: string[]) {
    state.issuerOptions = issuerOptions;
  },

  SET_ADDRESS_INFO(state, addressInfo: AddressInfo) {
    state.addressInfo = addressInfo;
  },

  SET_SPONSOR_ADDRESS_INFO(state, sponsorAddressInfo: SponsorAddressInfo) {
    state.sponsorAddressInfo = sponsorAddressInfo;
  },

  SET_ISSUE_STATE_OPTIONS(state, issueStateOptions: string[]) {
    state.issueStateOptions = issueStateOptions;
  },

  SET_SIGNUP_METHOD(state, signupMethod: string) {
    state.signupMethod = signupMethod;
  },
};

export default mutations;
